<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems"
                   class="breadcrumb mx-16">
    </v-breadcrumbs>

    <!-- <v-card> -->
    <v-row dense
           class="d-flex mx-16">
      <v-col cols="12"
             sm="12"
             md="12"
             lg="12"
             class="mt-2">
        <!-- download function -->
        <div class="my-3"
             v-if="selected.length > 0">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="success"
                     dark
                     v-bind="attrs"
                     v-on="on"
                     rounded
                     small
                     class="ml-2">
                <span class="font-weight-bold">Download</span>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item>
                <v-list-item-title>
                  <json-excel type="xls"
                              :data="selected"
                              :name="$route.params.id + '-Meta.xls'">
                    <v-btn text
                           block> <span class="font-weight-bold">xls</span> </v-btn>
                  </json-excel>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <json-excel type="csv"
                              :data="selected"
                              :name="$route.params.id + '-Meta.csv'">
                    <v-btn text
                           block> <span class="font-weight-bold">csv</span> </v-btn>
                  </json-excel>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <v-expansion-panels class="data-table-style">
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="mdi-menu-down"
                                      style="padding: 10px 25px">
              <div class="d-flex font-weight-bold">
                <span class="blue--text font-weight-bold mt-1">Display Columns</span>
                <v-chip outlined
                        small
                        color="success"
                        class="ml-2"
                        @click="showAll()">
                  Select All
                </v-chip>
                <v-chip outlined
                        small
                        color="error"
                        class="ml-2"
                        @click="showDefault()">
                  Select Default
                </v-chip>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="v-item-group">
                <v-checkbox v-for="(header, index) in headers"
                            :key="index"
                            :label="header.text"
                            :value="header.text"
                            v-model="selectedHeader"
                            dense
                            class="mx-1"></v-checkbox>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-data-table dense
                      v-model="selected"
                      class="data-table-style mt-1"
                      :headers="selectedHeaders"
                      fixed-header
                      :items="project_samples"
                      item-key="Sample Name"
                      show-select
                      :single-select="singleSelect"
                      :search="search"
                      :loading="loading"
                      loading-text="Loading... Please wait"
                      :items-per-page="itemsPerPage"
                      :footer-props="{
      showFirstLastPage: true,
      firstIcon: 'mdi-page-first',
      lastIcon: 'mdi-page-last',
      'items-per-page-options':[5,10,15,20,50,100,-1] }"
                      v-show="selectedHeaders && selectedHeaders.length > 0">
          <!-- header.data-table-select slot-->
          <template v-slot:[`header.data-table-select`]="{ on, props }">
            <v-simple-checkbox color="success"
                               v-bind="props"
                               v-on="on"></v-simple-checkbox>
          </template>

          <!-- item.data-table-select slot -->
          <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
            <v-simple-checkbox color="info"
                               :value="isSelected"
                               @input="select($event)"></v-simple-checkbox>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- </v-card> -->
  </v-container>
</template>

<script>
import JsonExcel from 'vue-json-excel';

import { getGtexMeta } from "node/projects"
export default {
  name: 'GTEx',
  components: {
    JsonExcel,
  },
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Projects',
          disabled: true,
        },
        {
          text: 'GTEx',
          disabled: false,
          href: '/ascancer/projects/gtex',
        },
        {
          text: this.$route.params.id,
          disabled: true,
        },
      ],
      project_meta: {},
      project_samples: [],
      selectedHeader: ['Experiment Accession',
        'Sample Name', 'Body Site', 'Histological Type',
        'Gender'],
      search: '',
      selected: [],
      singleSelect: false,
      loading: true,
      itemsPerPage: 15,
      headers: [
        { text: 'Project ID', value: 'Project ID', align: 'start', sortable: false, },
        { text: 'BioProject ID', value: 'BioProject ID', align: 'start', sortable: false, },
        { text: 'BioSample ID', value: 'BioSample ID', align: 'start', sortable: false, },
        { text: 'Experiment Accession', value: 'Experiment Accession', align: 'start', sortable: true, },
        { text: 'Subject ID', value: 'Subject ID', align: 'start', sortable: false, },
        { text: 'Sample Name', value: 'Sample Name', align: 'start' },
        { text: 'Body Site', value: 'Body Site', align: 'start' },
        { text: 'Histological Type', value: 'Histological Type', align: 'start' },
        { text: 'Is Tumor', value: 'Is Tumor', align: 'start' },
        { text: 'Gender', value: 'Sex', align: 'start' },
        { text: 'Library Layout', value: 'Library Layout', align: 'start', sortable: true },
        { text: 'Platform', value: 'Platform', align: 'start' },
        { text: 'Instrument Model', value: 'Instrument Model', align: 'start' },
        { text: 'AvgSpotLen', value: 'AvgSpotLen', align: 'start', sortable: true, },

      ],
    }
  },
  created() {
    // console.log(this.$route.params.id);
    this.getGtexMeta();
  },
  computed: {
    selectedHeaders() {
      return this.headers.filter(h => this.selectedHeader.includes(h.text))
    }
  },
  watch: {
    project_samples(val) {
      if (val) {
        this.loading = false;
      }
    },
  },
  methods: {
    // get all GTEx meta info
    async getGtexMeta() {
      let id = this.$route.params.id;
      await getGtexMeta(id).then(
        data => {
          if (data.length > 0) {
            // console.log(data);
            this.project_meta = data[0];
            this.project_samples = data[0].samples;
          } else {
            this.$router.push('/error')
          }
        }
      ).catch(err => console.error(err))
    },
    showAll() {
      this.headers.map(h => {
        this.selectedHeader.push(h.text)
      })
    },
    showNone() {
      this.selectedHeader = [];
    },
    showDefault() {
      this.selectedHeader = ['Experiment Accession',
        'Sample Name', 'Body Site', 'Histological Type',
        'Gender'];
    }
  }

}
</script>
<style scoped lang="sass">
.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

.v-card__title
  line-height: 0.5rem

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.v-item-group
  flex: 0 1 auto
  position: relative
  display: inline-flex
  flex-wrap: wrap
  max-width: 100%
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.v-input--selection-controls
  margin-top: 2px
  padding-top: 0px
</style>